import { addDaysToDate, isoDayOfWeek } from "./zonedTime";

/** Sunday-first convention already used by the application's calendar grid. */
export function startOfCalendarWeek(date: string): string {
  return addDaysToDate(date, -(isoDayOfWeek(date) % 7));
}

export interface RollingWindowLimits {
  firstStart: string;
  lastStart: string;
}

export function rollingWindowLimits(
  tripStart: string,
  tripEnd: string,
): RollingWindowLimits {
  const firstStart = startOfCalendarWeek(tripStart);
  const lastCandidate = startOfCalendarWeek(addDaysToDate(tripEnd, -21));
  return {
    firstStart,
    lastStart: lastCandidate < firstStart ? firstStart : lastCandidate,
  };
}

export function clampRollingWindowStart(
  start: string,
  limits: RollingWindowLimits,
): string {
  if (start < limits.firstStart) return limits.firstStart;
  if (start > limits.lastStart) return limits.lastStart;
  return start;
}

export function rollingWindowDates(start: string): string[] {
  return Array.from({ length: 28 }, (_, index) => addDaysToDate(start, index));
}
